module.exports = __webpack_public_path__ + "static/media/trackco.778c2d2e.svg";